import { NotificationTypes } from "./types";

export const setNotification = (page, type, message) => {
  return {
    type: NotificationTypes.SET_NOTIFICATION,
    payload: { page, type, message }
  };
};
